/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { UtilityActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        utilities: state.utilities
    });
}

function mapDispatchToProps(dispatch) {
    return {
        getTimezones: () => {
            dispatch(UtilityActions.fetchTimezones());
        },
        getUrlInfo: (url) => {
            dispatch(UtilityActions.fetchUrlInfo(url));
        },
        clearUrlInfo: () => {
            dispatch(UtilityActions.clearUrlInfo());
        },
        getCountries: () => {
            dispatch(UtilityActions.fetchCountries());
        },
        getRegions: (country) => {
            dispatch(UtilityActions.fetchRegions(country));
        },
        getFavorites: () => {
            dispatch(UtilityActions.fetchFavorites());
        },
        filterStore: (store, key, value, exact) => {
            dispatch(UtilityActions.filterStore(store, key, value, exact));
        },
        clearFilter: (store) => {
            dispatch(UtilityActions.clearFilter(store));
        },
        sortStore: (store, key, direction, groupFxns) => {
            dispatch(UtilityActions.sortStore(store, key, direction, groupFxns));
        },
        getRelatedHashtags: (query) => {
            dispatch(UtilityActions.fetchRelatedHashtags(query));
        },
        clearRelatedHashtags: () => {
            dispatch(UtilityActions.clearRelatedHashtags());
        }
	};
}

export default function UtilityProvider(Component) {

    class UtilityProvider extends React.Component {
        render() {
            return (
                <Component {...this.props}/>
            );
        }
    }

    UtilityProvider.displayName = "UtilityProvider";

    return connect(mapStateToProps, mapDispatchToProps)(UtilityProvider);
};
